import React from 'react';

import { Container, Title } from '@soluto-design/react';

import AccordionText, {
    AccordionTextProps,
} from '../../molecules/AccordionText';

export interface BlockFaqsSectionProps {
    items: AccordionTextProps[];
    title: string;
}

export default function BlockFaqsSection({
    title,
    items,
}: BlockFaqsSectionProps) {
    return (
        <section className="my-xxxl">
            <Container className="row">
                {title && (
                    <Title
                        isHtml
                        component="h3"
                        className="col-span-full lg:col-span-3  xl:col-span-5 text-h200 text-text-primary font-medium pb-xl lg:pb-0">
                        {title}
                    </Title>
                )}
                {!!items.length && (
                    <div className="col-span-full lg:col-span-4 lg:col-start-5  xl:col-span-6 xl:col-start-7 flex flex-col gap-16">
                        {items.map(({ title, text }) => {
                            return (
                                <AccordionText
                                    title={title}
                                    text={text}
                                    key={`faq-item-${title}`}
                                />
                            );
                        })}
                    </div>
                )}
            </Container>
        </section>
    );
}
